/**
 * focusSVGElement - allows the call to $(element).trigger('focus') to work properly on focusable elements inside an embedded SVG for IE11 and Safari
 *
 * IE11 lets us hack on the HTMLElement.prototype.focus method - we only fire when there is no originalEvent (meaning focus was triggered by JS from lightbox plugin rather than click or keyup)
 * Safari just needs the call to not be wrapped in jQuery object
 */
(function($) {
	$.fn.focusSVGElement = function () {
		var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
		var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
		if ( isIE11 || isSafari ) {
			this.on('focus',function (event) {
				// no originalEvent means focus was triggered by JS not from keyboard / mouse clicks
				if ( event && !event.originalEvent ) {
					if ( isIE11 ) {
						window.HTMLElement.prototype.focus.call(this);
					} else if ( isSafari ) {
						// Safari needs an unwrapped call to .trigger('focus')
						this.trigger('focus');
					}	
				}
			});
		}
		return this;
	};
}(jQuery));